module.exports = __webpack_public_path__ + "img/3.896de145.webp";